import React from 'react';

export function CheckboxMark({
  checked,
  indeterminate,
  activeColor,
  size,
}: {
  checked: boolean;
  indeterminate: boolean;
  activeColor: string;
  size: number | string;
}) {
  const filled = checked || indeterminate;
  return (
    <div
      style={{
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        borderRadius: 'var(--z-radius-xs, 4px)',
        border: 'none',
        backgroundColor: filled ? activeColor : 'var(--z-fill-2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all var(--z-ease-fast, 150ms)',
        color: '#ffffff',
        boxShadow: filled ? 'var(--z-sh-4)' : 'none',
      }}
      aria-hidden="true"
    >
      <CheckboxGlyph checked={checked} indeterminate={indeterminate} />
    </div>
  );
}

function CheckboxGlyph({ checked, indeterminate }: { checked: boolean; indeterminate: boolean }) {
  if (indeterminate) {
    return (
      <svg width="10" height="2" viewBox="0 0 10 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
        <line x1="1" y1="1" x2="9" y2="1" />
      </svg>
    );
  }
  if (!checked) return null;
  return (
    <svg
      className="animate-zcheckBounce"
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="1.5 5 4.5 8 10.5 2" />
    </svg>
  );
}

export function CheckboxCopy({
  label,
  description,
  descId,
}: {
  label?: React.ReactNode;
  description?: React.ReactNode;
  descId?: string;
}) {
  if (!label && !description) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {label ? (
        <span style={{ fontSize: '13.5px', fontWeight: 500, color: 'var(--z-text)', lineHeight: 1.3 }}>
          {label}
        </span>
      ) : null}
      {description ? (
        <span id={descId} style={{ fontSize: '12px', color: 'var(--z-text-3)', marginTop: '1px' }}>
          {description}
        </span>
      ) : null}
    </div>
  );
}
